/**
 * LatencyAnalysisSection - Container for latency analysis charts
 *
 * Features:
 * - Displays two charts simultaneously:
 *   1. Percentile Latency (P50/P95/P99 over time)
 *   2. Latency Histogram (distribution across buckets)
 */

import React from 'react';
import { palette, typography, components } from '../../utils/designTokens';
import LatencyPercentilesChart from './LatencyPercentilesChart';
import LatencyDistributionChart from './LatencyDistributionChart';
import { getPercentileLatencyChartTooltip, getLatencyHistogramTooltip } from '../../utils/tooltips';

const LatencyAnalysisSection = ({ latencyOverTimeData, latencyDistribution, timeWindow, appId, environment }) => {
  return (
    <div className="flex flex-col gap-4">
      {/* Chart 1: Latency Percentiles */}
      <div className={`${components.card.bg} ${components.card.rounded} ${components.card.padding}`}
           style={{ borderLeft: `1px solid ${components.card.borderColor}` }}>
        <h3 className={`${typography.size.xs} ${typography.weight.semibold} uppercase tracking-wide mb-4`}
            style={{ color: palette.text.neutral }}
            title={getPercentileLatencyChartTooltip()}>
          Latency Percentiles
        </h3>
        <LatencyPercentilesChart
          data={latencyOverTimeData}
          timeWindow={timeWindow}
          appId={appId}
          environment={environment}
        />
      </div>

      {/* Chart 2: Latency Distribution */}
      <div className={`${components.card.bg} ${components.card.rounded} ${components.card.padding}`}
           style={{ borderLeft: `1px solid ${components.card.borderColor}` }}>
        <h3 className={`${typography.size.xs} ${typography.weight.semibold} uppercase tracking-wide mb-4`}
            style={{ color: palette.text.neutral }}
            title={getLatencyHistogramTooltip()}>
          Latency Distribution
        </h3>
        <LatencyDistributionChart
          data={latencyDistribution}
          appId={appId}
          environment={environment}
          timeWindow={timeWindow}
        />
      </div>
    </div>
  );
};

export default LatencyAnalysisSection;
